import React, { useState } from 'react';
import Button from '@msi/cobalt-react/button';
import Treeview, { TreeviewTitle, TreeviewItem } from '@msi/cobalt-react/treeview';
import './apiEndpoints.css';

interface EndpointsProps {
    selectedEndpoint: any;
}

const ApiEndpoints: React.FC<EndpointsProps> = ({ selectedEndpoint }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        selectedEndpoint &&
        <div className='responses-container'>
            <div key={selectedEndpoint?.id} className='endpoint-item'>
                <div className='endpoint-content-wrapper'>
                    <div className='col-lg-5 responses-column'>
                        <div className='summary'>
                            <Button className='method-button' buttonType='secondary' text={selectedEndpoint?.method || 'GET'} style={{ borderRadius: '25px', border: '1px solid' }} />
                            <p>{selectedEndpoint?.description}</p>
                        </div>
                        <h4>Responses</h4>
                        {selectedEndpoint?.responses && Object.keys(selectedEndpoint.responses).length > 0 ? (
                            Object.entries(selectedEndpoint?.responses).map(([statusCode, responseData]: [string, any]) => (
                                <div key={statusCode} className="response-item">
                                    <span className='responseStatus'>{statusCode}</span>
                                    <p> {responseData.description || (
                                        statusCode === '200' ? 'Ok' : 
                                        statusCode === '201' ? 'Created' :
                                        statusCode === '204' ? 'No Content' :
                                        statusCode === '400' ?  'Bad Request' :
                                        statusCode === '403' ? 'Forbidden' :
                                        statusCode === '404' ? 'Not Found' : 
                                        statusCode === '502' ? 'Bad Gateway' : 
                                        'No description')}
                                    </p>
                                    <Treeview>
                                        <TreeviewTitle title="" className="custom-treeview-border">
                                            <TreeviewItem content={'Show response attributes'} onClick={() => setIsExpanded(!isExpanded)} isExpanded={isExpanded} className="response-attributes">
                                                {responseData.content && Object.values(responseData.content).some((content: any) => content.schema?.resolvedSchema?.properties) ? (
                                                    Object.entries(responseData.content).map(([mediaType, contentData]: [string, any]) => {
                                                        if (contentData.schema?.resolvedSchema?.properties && Object.keys(contentData.schema.resolvedSchema.properties).length > 0) {
                                                            return Object.entries(contentData.schema.resolvedSchema?.properties).map(([propertyName, property]: [string, any]) => (
                                                                <div className='response-property'>
                                                                    <div key={propertyName} className='responses'>
                                                                        <strong>{propertyName}</strong>
                                                                        <span className='param-type' style={{ marginLeft: '10px' }}>{property.type?.toUpperCase() || '{ }'}</span>
                                                                    </div>
                                                                    <div className='values-examples' style={{ marginLeft: '20px' }}>
                                                                        {property.enum && (
                                                                            <div>
                                                                                Values:
                                                                                {property.enum.map((value: any, index: number) => (
                                                                                    <span><div key={index} style={{ marginLeft: '10px' }}>• {value}</div></span>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                        {property.description && <div>Description: {property.description}</div>}
                                                                        {property.format && <div>Format: {property.format}</div>}
                                                                        {property.example && <div>Example: {property.example}</div>}
                                                                    </div>
                                                                </div>

                                                            ));
                                                        }
                                                        return null;
                                                    })
                                                ) : (
                                                    <span className="response-property">No response data available</span>
                                                )}
                                            </TreeviewItem>
                                        </TreeviewTitle>
                                    </Treeview>
                                </div>
                            ))) : (
                            <span className="response-description">No response data available</span>
                        )}
                    </div>

                    <div className='col-lg-5 curl-column'>
                        <div className='curl-box'>
                            <div className='endpoint-path'>
                                <span className='method-type'>{selectedEndpoint?.method}</span>
                                <span className='path'>{selectedEndpoint?.path}</span>
                            </div>
                            <div className="endpoint-description">
                                <span>curl \</span>
                                <span> --request {selectedEndpoint?.method || 'GET'} '{selectedEndpoint?.path}' \</span>

                            </div>
                        </div>

                        <div className='curl-box'>
                            <div className='endpoint-path'>
                                <span className='method-type'>Request Examples</span>
                            </div>
                            <div className="endpoint-description">
                                <div className="schema-info">
                                    <p>{'{'}</p>
                                    {selectedEndpoint?.requestBody?.content && Object.keys(selectedEndpoint.requestBody?.content).length > 0 ? (
                                        Object.entries(selectedEndpoint.requestBody?.content).map(([contentType, requestData]: [string, any]) => {
                                            if (requestData.schema?.resolvedSchema?.properties) {
                                                return Object.entries(requestData.schema.resolvedSchema.properties).map(([propertyName, property]: [string, any]) => (
                                                    <div key={propertyName} className="schema-item">
                                                        <span>"{propertyName}": "{property.type?.toUpperCase() || 'UNKNOWN'}"</span>
                                                    </div>
                                                ));
                                            } else if (requestData.schema?.type) {
                                                return (
                                                    <div key={contentType} className="schema-item">
                                                        <span>{contentType}: {requestData.schema.type}</span>
                                                    </div>
                                                );
                                            }
                                            return (
                                                <div key={contentType} className="schema-item">
                                                    <span>No schema available for {contentType}</span>
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <div className="schema-item">
                                            <span>No request body parameters</span>
                                        </div>
                                    )}
                                    <p>{'}'}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ApiEndpoints;